// NOTICE: Country code matters :)
export const freightRateOrder = {
  origin_location: "Origin name",
  destination_location: "Destination name",
  service: "Service name",
  price: "Lowest price first",
};
